import './forms';
import './counter';
import checkEnrollment from './check-enrollment';
import { wireIglesiaAutofill } from './iglesia-select';

let iglesiaSelect = document.querySelector('#RegisterFormFieldCeciIglesiaSelect')
let pastor = document.querySelector('#RegisterFormFieldCeciIglesiaPastor')
let telefono = document.querySelector('#RegisterFormFieldCeciIglesiaTelefono')
let nombreLibreInput = document.querySelector('#RegisterFormFieldCeciIglesiaNombre')
let nombreLibreWrapper = document.querySelector('#iglesiaNombreLibreWrapper')
let cedulaID       = document.querySelector('#RegisterFormFieldCeciCedula')

wireIglesiaAutofill(iglesiaSelect, {
    pastorInput: pastor,
    telefonoInput: telefono,
    nombreLibreInput: nombreLibreInput,
    nombreLibreWrapper: nombreLibreWrapper,
})

function getData(response){
    let form         = document.querySelector('.form-register');
    let formElements = Array.from(form.elements)
    let button       = document.querySelector('.btn-register')
    let asistenteId  = document.querySelector('#asistenteId')
    let checkEnrollmentText = document.querySelector('#checkEnrollmentText')
    let ceci_id = 0;

    for(let data in response){
        formElements.forEach(function(el){

            if(data == 'ceci_id'){
                ceci_id = parseInt(response[data])
            }

            if(el.dataset.val == data){
                el.value = response[data]

                if(el.type == 'checkbox'){
                    if(response[data]== 'SI'){
                        el.value = 'on'
                        el.checked = true
                    }else{
                        el.value = ''
                        el.checked = false
                    }
                }

                if(el.tagName == 'SELECT'){
                    el.dispatchEvent(new Event('change', { bubbles: true }))
                }

                if(response[data] != null){
                    el.removeAttribute('disabled')
                    el.setAttribute('data-valid', true)
                }
            }
        })

        form._method.value = 'PATCH'
        form.action = document.location.origin + '/registro/' + asistenteId.value

        if(ceci_id == 2){
            button.classList.add('is-blocked')
            button.textContent = '¡Ya estas registrado(a)!'
            checkEnrollmentText.style.color = 'tomato'
            checkEnrollmentText.textContent = 'Su usuario ya esta registrado para este CECI'
        } else{
            button.classList.remove('is-blocked')
            button.textContent = 'Inscribirme'
            checkEnrollmentText.textContent = 'Si participaste en el CECI anterior, basta con escribir tu cédula'
        }
    }
}

cedulaID.addEventListener('blur', function(){
    if(cedulaID.value != '' && cedulaID.value.length >= 6){
        let formRegister = document.querySelector('.form-register')
        let checkEnrollmentUrl = formRegister.querySelector('[name="url_to_check"]')
        let formData = new FormData()
        let token = formRegister.querySelector('[name="_token"]').value
        formData.append('cedula', cedulaID.value)
        formData.append('email', '')
        checkEnrollment(checkEnrollmentUrl.value, token, formData, getData, function(){
            let button = document.querySelector('.btn-register')
            button.classList.remove('is-blocked')
        })
    }
})
